export const MODULE_STATS = [
  {
    id: 'aim_switch_time',
    nameRu: 'Бдительный',
    nameEn: 'Vigilant',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Время прицеливания',
    parameterEn: 'Aim switch time',
    slots: ['prefix']
  },
  {
    id: 'hip_spread',
    nameRu: 'Устойчивый',
    nameEn: 'Steady',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Разброс от бедра',
    parameterEn: 'Hip spread',
    slots: ['prefix']
  },
  {
    id: 'spread',
    nameRu: 'Суммирующий',
    nameEn: 'Summing',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Разброс',
    parameterEn: 'Spread',
    slots: ['prefix']
  },
  {
    id: 'ergonomics',
    nameRu: 'Комфортный',
    nameEn: 'Comfortable',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Эргономика',
    parameterEn: 'Ergonomics',
    slots: ['prefix']
  },
  {
    id: 'shoot_factor_decrement',
    nameRu: 'Стабильный',
    nameEn: 'Stable',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Стабилизация',
    parameterEn: 'Stabilization',
    slots: ['prefix']
  },
  {
    id: 'wiggle',
    nameRu: 'Гармоничный',
    nameEn: 'Harmonious',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Покачивание',
    parameterEn: 'Wiggle',
    slots: ['prefix']
  },
  {
    id: 'recoil',
    nameRu: 'Вертикальный',
    nameEn: 'Vertical',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Отдача',
    parameterEn: 'Recoil',
    slots: ['prefix']
  },
  {
    id: 'horizontal_recoil',
    nameRu: 'Горизонтальный',
    nameEn: 'Horizontal',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Горизонт. отдача',
    parameterEn: 'Horizontal recoil',
    slots: ['prefix']
  },
  {
    id: 'recoil_gain',
    nameRu: 'Плавный',
    nameEn: 'Smooth',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Нарастание отдачи',
    parameterEn: 'Recoil gain',
    slots: ['prefix']
  },
  {
    id: 'draw_time',
    nameRu: 'Мгновенный',
    nameEn: 'Instant',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Время доставания',
    parameterEn: 'Draw speed',
    slots: ['prefix']
  },
  {
    id: 'aiming_speed_modifier',
    nameRu: 'Фокусный',
    nameEn: 'Focal',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Скорость в прицеливании',
    parameterEn: 'Aiming speed',
    slots: ['prefix']
  },
  {
    id: 'equipped_speed_modifier',
    nameRu: 'Подвижный',
    nameEn: 'Mobile',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Скорость с оружием',
    parameterEn: 'Speed',
    slots: ['prefix']
  },
  {
    id: 'aim_switch_time',
    nameRu: 'Дрожащий',
    nameEn: 'Shivering',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Время прицеливания',
    parameterEn: 'Aim switch time',
    slots: ['suffix']
  },
  {
    id: 'hip_spread',
    nameRu: 'Неустойчивый',
    nameEn: 'Unsteady',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Разброс от бедра',
    parameterEn: 'Hip spread',
    slots: ['suffix']
  },
  {
    id: 'spread',
    nameRu: 'Отрицающий',
    nameEn: 'Denying',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Увел. разброс',
    parameterEn: 'Spread',
    slots: ['suffix']
  },
  {
    id: 'ergonomics',
    nameRu: 'Дискомфортный',
    nameEn: 'Discomfortable',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Эргономика',
    parameterEn: 'Ergonomics',
    slots: ['suffix']
  },
  {
    id: 'shoot_factor_decrement',
    nameRu: 'Нестабильный',
    nameEn: 'Unstable',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Стабилизация',
    parameterEn: 'Stabilization',
    slots: ['suffix']
  },
  {
    id: 'wiggle',
    nameRu: 'Люфтящий',
    nameEn: 'Shaky',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Покачивание',
    parameterEn: 'Wiggle',
    slots: ['suffix']
  },
  {
    id: 'recoil',
    nameRu: 'Уходящий',
    nameEn: 'Receding',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Отдача',
    parameterEn: 'Recoil',
    slots: ['suffix']
  },
  {
    id: 'horizontal_recoil',
    nameRu: 'Сдвигающий',
    nameEn: 'Shifting',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Горизонт. отдача',
    parameterEn: 'Horizontal recoil',
    slots: ['suffix']
  },
  {
    id: 'recoil_gain',
    nameRu: 'Резкий',
    nameEn: 'Sharp',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Нарастание отдачи',
    parameterEn: 'Recoil gain',
    slots: ['suffix']
  },
  {
    id: 'draw_time',
    nameRu: 'Инертный',
    nameEn: 'Inert',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Время доставания',
    parameterEn: 'Draw speed',
    slots: ['suffix']
  },
  {
    id: 'aiming_speed_modifier',
    nameRu: 'Медлительный',
    nameEn: 'Slow',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Скорость в прицеливании',
    parameterEn: 'Aiming speed',
    slots: ['suffix']
  },
  {
    id: 'equipped_speed_modifier',
    nameRu: 'Заторможенный',
    nameEn: 'Sluggish',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Скорость с оружием',
    parameterEn: 'Speed',
    slots: ['suffix']
  },
  {
    id: 'inside',
    nameRu: 'Компрессор',
    nameEn: 'Compressor',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Урон вблизи',
    parameterEn: 'Close range damage',
    slots: ['affix']
  },
  {
    id: 'inside2',
    nameRu: 'Декомпрессор',
    nameEn: 'Decompressor',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Урон вдаль',
    parameterEn: 'Long range damage',
    slots: ['affix']
  },
  {
    id: 'equalizer_op',
    nameRu: 'Палач',
    nameEn: 'Executioner',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Урон по конечностям',
    parameterEn: 'Limb damage',
    slots: ['affix']
  },
  {
    id: 'surge',
    nameRu: 'Пробойник',
    nameEn: 'Piercer',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Доп. скорость после убийства',
    parameterEn: 'Speed after kill',
    slots: ['affix']
  },
  {
    id: 'berserk',
    nameRu: 'Агрессор',
    nameEn: 'Aggressor',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Доп. лечение после убийства',
    parameterEn: 'Heal after kill',
    slots: ['affix']
  },
  {
    id: 'concentration',
    nameRu: 'Губитель',
    nameEn: 'Destroyer',
    type: 'buff',
    groupRu: 'Аномалия',
    groupEn: 'Anomaly',
    parameterRu: 'Минус перезарядка/отдача после убийства',
    parameterEn: 'Reduced reload/recoil after kill',
    slots: ['affix']
  },
  {
    id: 'gyroscope',
    nameRu: 'Регулятор',
    nameEn: 'Regulator',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Нарастание отдачи (Сильно)',
    parameterEn: 'Recoil gain (strong)',
    slots: ['affix']
  },
  {
    id: 'aim_switch_time',
    nameRu: 'Стрелок',
    nameEn: 'Shooter',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Скорость прицеливания',
    parameterEn: 'Aim switch time',
    slots: ['affix']
  },
  {
    id: 'hip_spread',
    nameRu: 'Проектор',
    nameEn: 'Projector',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Разброс от бедра',
    parameterEn: 'Hip spread',
    slots: ['affix']
  },
  {
    id: 'spread',
    nameRu: 'Контроллер',
    nameEn: 'Controller',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Разброс',
    parameterEn: 'Spread',
    slots: ['affix']
  },
  {
    id: 'acceleration',
    nameRu: 'Термос',
    nameEn: 'Thermos',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Доп. урон первые 5пт',
    parameterEn: 'Extra damage first 5pts',
    slots: ['affix']
  },
  {
    id: 'finish',
    nameRu: 'Завершитель',
    nameEn: 'Finisher',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Доп. урон последние 5пт',
    parameterEn: 'Extra damage last 5pts',
    slots: ['affix']
  },
  {
    id: 'ergonomics',
    nameRu: 'Биостабилизатор',
    nameEn: 'Biostabilizer',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Эргономика',
    parameterEn: 'Ergonomics',
    slots: ['affix']
  },
  {
    id: 'shoot_factor_decrement',
    nameRu: 'Гаситель',
    nameEn: 'Dampener',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Стабилизация',
    parameterEn: 'Stabilization',
    slots: ['affix']
  },
  {
    id: 'wiggle',
    nameRu: 'Вариатор',
    nameEn: 'Variator',
    type: 'buff',
    groupRu: 'Удобство',
    groupEn: 'Convenience',
    parameterRu: 'Покачивание',
    parameterEn: 'Wiggle',
    slots: ['affix']
  },
  {
    id: 'recoil',
    nameRu: 'Держатель',
    nameEn: 'Holder',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Отдача',
    parameterEn: 'Recoil',
    slots: ['affix']
  },
  {
    id: 'horizontal_recoil',
    nameRu: 'Фиксатор',
    nameEn: 'Fixer',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Горизонтальная отдача',
    parameterEn: 'Horizontal recoil',
    slots: ['affix']
  },
  {
    id: 'recoil_gain',
    nameRu: 'Седатор',
    nameEn: 'Sedator',
    type: 'buff',
    groupRu: 'Контроль',
    groupEn: 'Control',
    parameterRu: 'Нарастание отдачи',
    parameterEn: 'Recoil gain',
    slots: ['affix']
  },
  {
    id: 'sadist',
    nameRu: 'Охотник',
    nameEn: 'Hunter',
    type: 'buff',
    groupRu: 'Бойник',
    groupEn: 'Fighter',
    parameterRu: 'Доп. урон за каждый % хп',
    parameterEn: 'Extra damage per HP%',
    slots: ['affix']
  },
  {
    id: 'sledgehammer',
    nameRu: 'Перфоратор',
    nameEn: 'Perforator',
    type: 'buff',
    groupRu: 'Бойник',
    groupEn: 'Fighter',
    parameterRu: 'Доп. урон по пластинам',
    parameterEn: 'Extra plate damage',
    slots: ['affix']
  },
  {
    id: 'marksman',
    nameRu: 'Снайпер',
    nameEn: 'Sniper',
    type: 'buff',
    groupRu: 'Бойник',
    groupEn: 'Fighter',
    parameterRu: 'Доп. урон в голову',
    parameterEn: 'Extra headshot damage',
    slots: ['affix']
  },
  {
    id: 'draw_time',
    nameRu: 'Экстрактор',
    nameEn: 'Extractor',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Скорость доставания',
    parameterEn: 'Draw speed',
    slots: ['affix']
  },
  {
    id: 'aiming_speed_modifier',
    nameRu: 'Оператор',
    nameEn: 'Operator',
    type: 'buff',
    groupRu: 'Точность',
    groupEn: 'Accuracy',
    parameterRu: 'Скорость в прицеливании',
    parameterEn: 'Aiming speed',
    slots: ['affix']
  },
  {
    id: 'equipped_speed_modifier',
    nameRu: 'Слайдер',
    nameEn: 'Slider',
    type: 'buff',
    groupRu: 'Скорость',
    groupEn: 'Speed',
    parameterRu: 'Скорость c оружием',
    parameterEn: 'Speed',
    slots: ['affix']
  }
]

export const QUALITY_LIST = [
  {
    value: 0,
    label: 'Обычный',
    labelEn: 'Common',
    color: '#A0A0A0',
    bgColor: 'rgba(128, 128, 128, 0.2)',
    borderColor: '#7C7CFF'
  },
  {
    value: 1,
    label: 'Необычный',
    labelEn: 'Uncommon',
    color: '#90EE90',
    bgColor: 'rgba(144, 238, 144, 0.2)',
    borderColor: '#90EE90'
  },
  {
    value: 2,
    label: 'Особый',
    labelEn: 'Special',
    color: '#87CEEB',
    bgColor: 'rgba(135, 206, 235, 0.2)',
    borderColor: '#87CEEB'
  },
  {
    value: 3,
    label: 'Редкий',
    labelEn: 'Rare',
    color: '#DDA0DD',
    bgColor: 'rgba(147, 112, 219, 0.2)',
    borderColor: '#DDA0DD'
  },
  {
    value: 4,
    label: 'Исключительный',
    labelEn: 'Exceptional',
    color: '#DC143C',
    bgColor: 'rgba(220, 20, 60, 0.2)',
    borderColor: '#DC143C'
  },
  {
    value: 5,
    labelEn: 'Legendary',
    color: '#FFD700',
    bgColor: 'rgba(255, 215, 0, 0.2)',
    borderColor: '#FFD700'
  }
]

export const LIST = new Set([
  'inside',
  'inside2',
  'equalizer_op',
  'surge',
  'berserk',
  'concentration',
  'gyroscope',
  'acceleration',
  'finish',
  'sadist',
  'sledgehammer',
  'marksman'
])
